<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card>
          <l-data-table
          title-text="微信模板列表"
          :headers="wechatTemplateHeader"
          :get-data-func="getWechatTemplateList"></l-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import LDataTable from '../../../ladmin/components/LDataTable/LDataTable'
import {time} from '../../../ladmin/utils/time'
export default {
  name: 'wechatTemplateList',
  components: {LDataTable},
  data () {
    return {
      wechatTemplateHeader: [
        {text: '模板标题', align: 'left', sortable: false, value: 'name'},
        {text: '所属模块', align: 'left', sortable: false, value: 'module'},
        {text: '模板类型', align: 'left', sortable: false, value: 'type'},
        {text: '操作人', align: 'left', sortable: false, value: 'editor'},
        {text: '添加时间', align: 'left', sortable: true, value: 'creationTime', f: (v) => time.stringify(v), placeholder: 'N/A'},
      ],
    }
  },
  methods: {
    async getWechatTemplateList ({pagination, sortStack, filterItems = [], search}) {
      let searchParam = {
        'searchParam': {
          'type': {
            'keyword': 'wechat',
            'order': 'ASC'
          },
          'name': {
            'keyword': search,
            'order': 'ASC'
          },
        }
      }
      let res = await this.$store.dispatch('messageManagement/getTemplateList', {pagination: pagination, searchParam: searchParam})
      if (res.data.status === 1) {
        return {items: res.data.data.content, amount: res.data.data.totalElements}
      }
      else {
        this.$L.alert('error', {message: '查询失败，原因:' + res.data.msg})
      }
    },
  }
}
</script>
